import React from 'react';
import { motion } from 'framer-motion';

const ProductSkeleton = () => {
    return (
        <div className="product-card h-full flex flex-col relative overflow-hidden bg-raya-card border border-raya-border rounded-xl">
            {/* Shimmer Overlay */}
            <motion.div
                className="absolute inset-0 z-10"
                initial={{ x: '-100%' }}
                animate={{ x: '100%' }}
                transition={{
                    repeat: Infinity,
                    duration: 1.5,
                    ease: "linear",
                }}
                style={{
                    background: 'linear-gradient(90deg, transparent, rgba(212, 175, 55, 0.05), transparent)',
                }}
            />

            {/* Image Skeleton */}
            <div className="product-image-wrapper bg-raya-bg-off dark:bg-zinc-800/50 relative overflow-hidden">
                <div className="absolute inset-0 flex items-center justify-center opacity-10">
                    <svg className="w-12 h-12" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1} d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z" />
                    </svg>
                </div>
            </div>

            {/* Content Skeleton */}
            <div className="p-4 flex-grow flex flex-col gap-3">
                <div className="flex justify-between items-start gap-4">
                    <div className="h-6 w-3/4 rounded-md bg-raya-bg-off dark:bg-zinc-800/50" />
                    <div className="h-6 w-1/4 rounded-md bg-raya-bg-off dark:bg-zinc-800/50" />
                </div>

                <div className="h-4 w-1/2 rounded-md bg-raya-bg-off dark:bg-zinc-800/50" />

                <div className="space-y-2 mt-2">
                    <div className="h-4 w-full rounded-md bg-raya-bg-off dark:bg-zinc-800/50" />
                    <div className="h-4 w-5/6 rounded-md bg-raya-bg-off dark:bg-zinc-800/50" />
                </div>

                <div className="mt-auto pt-4 flex items-center justify-between">
                    <div className="h-5 w-24 rounded-md bg-raya-bg-off dark:bg-zinc-800/50" />
                    <div className="h-10 w-32 rounded-lg bg-raya-accent/10 border border-raya-accent/20" />
                </div>
            </div>
        </div>
    );
};

export default ProductSkeleton;
